const dev = {
  API_ENDPOINT_URL: "http://localhost:8080/backoffice",
};

const prod = {
  API_ENDPOINT_URL: "https://portal.partelecom.com/backend",
};

const getEnv = () => {
  switch (process.env.NODE_ENV) {
    case "development":
      return dev;
    case "production":
      return prod;
    default:
      break;
  }
};

export const env = getEnv();
